import { useLanguage } from "@/context/LanguageContext";
import { useLegal } from "@/context/LegalContext";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

const Footer = () => {
  const { t } = useLanguage();
  const { open } = useLegal();
  const year = new Date().getFullYear();
  const links = [
    { id: "about", label: t.nav.about },
    { id: "services", label: t.nav.services },
    { id: "portfolio", label: t.nav.portfolio },
    { id: "contact", label: t.nav.contact },
  ];

  return (
    <footer data-testid="site-footer" className="bg-[#071523] text-white">
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10 py-16">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <div className="flex items-center gap-3">
              <img
                src="/brand/monogram.png"
                alt="Ing. Alessandro Perago"
                className="h-11 w-auto brightness-0 invert"
              />
              <span className="font-display font-bold tracking-tight text-lg">Ing. Alessandro Perago</span>
            </div>
            <p className="mt-5 text-white/50 text-sm max-w-md leading-relaxed">{t.footer.tagline}</p>
          </div>

          <div className="md:col-span-3">
            <h4 className="overline text-white/40 mb-4">Menu</h4>
            <ul className="space-y-2.5">
              {links.map((l) => (
                <li key={l.id}>
                  <button
                    data-testid={`footer-nav-${l.id}`}
                    onClick={() => scrollTo(l.id)}
                    className="text-white/70 text-sm hover:text-[#B87333] transition-colors"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="overline text-white/40 mb-4">{t.contact.infoTitle}</h4>
            <ul className="space-y-2.5 text-sm text-white/70">
              <li><a href="mailto:alessandro.perago@ingpec.eu" className="hover:text-[#B87333] transition-colors">alessandro.perago@ingpec.eu</a></li>
              <li>Bari — Italia</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/40">
          <span>© {year} Alessandro Perago. {t.footer.rights}</span>
          <div className="flex items-center gap-5">
            <button
              data-testid="footer-privacy"
              onClick={() => open("privacy")}
              className="hover:text-[#B87333] transition-colors"
            >
              {t.footer.privacy}
            </button>
            <button
              data-testid="footer-cookies"
              onClick={() => open("cookies")}
              className="hover:text-[#B87333] transition-colors"
            >
              {t.footer.cookies}
            </button>
            <button
              data-testid="footer-notes"
              onClick={() => open("notes")}
              className="hover:text-[#B87333] transition-colors"
            >
              {t.footer.notes}
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
